import { PageTemplate, HeaderTemplate, ButtonLink } from "../styles";
import { useQuery } from "../utils";

const UserVerificationResult = () => {
  const queryParams = useQuery();
  const message = queryParams.get("message");
  const success = queryParams.get("success");
  const resultTitle = success === "true" ? "success" : "failed";
  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Email Verification</h1>
          </div>
          {success === "true" && (
            <div className="breadcrumb">
              <ButtonLink to="/designs" className="small clear">
                Browse Designs
              </ButtonLink>
            </div>
          )}
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <div className="content-page user-verification-message">
          <h2 className={resultTitle}>Verification {resultTitle}</h2>

          {success === "true" ? (
            <>
              <p>{message}</p>
              <ButtonLink to="/account" className="autoFitCenter">
                Go To Account
              </ButtonLink>
            </>
          ) : (
            message
          )}
        </div>
      </PageTemplate>
    </>
  );
};

export default UserVerificationResult;
